import { ICrumb } from '@ui-modules/types';
import { EntryPage } from '@pages';
import backgroundImage from '@assets/img/default/background.jpg';
import RequestDetailsPage from '@pages/RequestsDetailsPage';
import AssignmentListPage from '@pages/AssignmentsListPage';
import RequestsListPage from './pages/RequestsListPage';

export default [
  {
    path: '/',
    Component: EntryPage,
    isBackgroundImage: true,
    backgroundImage,
  },
  {
    path: '/requests',
    Component: RequestsListPage,
    name: 'Freight Requests',
    isBackgroundImage: true,
    isNavigation: true,
    backgroundImage,
  },
  {
    path: '/requests/:id',
    Component: RequestDetailsPage,
    name: 'Freight Details',
    isBackgroundImage: true,
    isNavigation: true,
    backgroundImage,
  },
  {
    path: '/assignments',
    Component: AssignmentListPage,
    name: 'Freights Assignment',
    isBackgroundImage: true,
    isNavigation: true,
    backgroundImage,
  },
  {
    path: '/assignments/:id',
    Component: RequestDetailsPage,
    name: 'Freight Details',
    isBackgroundImage: true,
    isNavigation: true,
    backgroundImage,
  },
] as ICrumb[];
